<script>
import LandingPageMixin from '@/mixins/landingpage'

export default {
  name: 'LandingPageDefault',
  mixins: [ LandingPageMixin ],
  computed: {
    bg () {
      if (!this.isLowerThanIE11) {
        return `background-image: url(/img/bg3.jpg);`
      }
      return `background-image: url(/img/background_notcompatible.jpg);`
    },
    container () {
      if (!this.isLowerThanIE11) {
        return 'container'
      }
      return 'container-fluid'
    }
  }
}
</script>

<style lang="scss" scoped>
@import './bootstrap.scss';
@import './main.scss';
</style>

<template>
  <div class="default" :style="bg">
    <div :class="container">
      <div class="jumbotron bg-transparent" v-if="!isLowerThanIE11">
        <h1 class="display-1">404</h1>
        <p class="lead">How did you get here</p>
        <p class="lead2">Sorry we can't seem to find the page you're looking for.</p>
      </div>
      <div class="jumbotron bg-transparent" style="padding: 8rem 0;" v-else>
        <div class="row">
          <div class="col-6 text-center">
            <h1 class="display-1">&nbsp;</h1>
            <p class="lead">Your Browser is not supported.</p>
            <p class="lead2">Please copy and paste this link into the latest version of <br>Firefox, Chrome, Safari, Edge or Opera</p>
            <img style="margin:1em 0em;" src="/img/browsers.png">
          </div>
          <div class="col-6"></div>
        </div>
      </div>
    </div>
  </div>
</template>
